export default __webpack_public_path__ + "static/media/face-3.e08fd425.jpg";